// source: accounts/protos/vpnserver_armadillo.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */


var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var accounts_protos_vpnserver_pb = require('../../accounts/protos/vpnserver_pb.js');
goog.object.extend(proto, accounts_protos_vpnserver_pb);
goog.exportSymbol('proto.accounts.protos.VPNServerArmadilloCreateResponse', null, global);
goog.exportSymbol('proto.accounts.protos.VPNServerArmadilloError', null, global);
goog.exportSymbol('proto.accounts.protos.VPNServerArmadilloGetResponse', null, global);
goog.exportSymbol('proto.accounts.protos.VPNServerArmadilloListResponse', null, global);
goog.exportSymbol('proto.accounts.protos.VPNServerArmadilloObject', null, global);
goog.exportSymbol('proto.accounts.protos.VPNServerArmadilloSetRequest', null, global);
goog.exportSymbol('proto.accounts.protos.VPNServerArmadilloSetResponseInvalid', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accounts.protos.VPNServerArmadilloObject = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accounts.protos.VPNServerArmadilloObject, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accounts.protos.VPNServerArmadilloObject.displayName = 'proto.accounts.protos.VPNServerArmadilloObject';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accounts.protos.VPNServerArmadilloError = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.accounts.protos.VPNServerArmadilloError.repeatedFields_, null);
};
goog.inherits(proto.accounts.protos.VPNServerArmadilloError, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accounts.protos.VPNServerArmadilloError.displayName = 'proto.accounts.protos.VPNServerArmadilloError';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accounts.protos.VPNServerArmadilloListResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.accounts.protos.VPNServerArmadilloListResponse.repeatedFields_, null);
};
goog.inherits(proto.accounts.protos.VPNServerArmadilloListResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accounts.protos.VPNServerArmadilloListResponse.displayName = 'proto.accounts.protos.VPNServerArmadilloListResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accounts.protos.VPNServerArmadilloCreateResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accounts.protos.VPNServerArmadilloCreateResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accounts.protos.VPNServerArmadilloCreateResponse.displayName = 'proto.accounts.protos.VPNServerArmadilloCreateResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accounts.protos.VPNServerArmadilloGetResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accounts.protos.VPNServerArmadilloGetResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accounts.protos.VPNServerArmadilloGetResponse.displayName = 'proto.accounts.protos.VPNServerArmadilloGetResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accounts.protos.VPNServerArmadilloSetRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accounts.protos.VPNServerArmadilloSetRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accounts.protos.VPNServerArmadilloSetRequest.displayName = 'proto.accounts.protos.VPNServerArmadilloSetRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accounts.protos.VPNServerArmadilloSetResponseInvalid = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accounts.protos.VPNServerArmadilloSetResponseInvalid, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accounts.protos.VPNServerArmadilloSetResponseInvalid.displayName = 'proto.accounts.protos.VPNServerArmadilloSetResponseInvalid';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accounts.protos.VPNServerArmadilloObject.prototype.toObject = function(opt_includeInstance) {
  return proto.accounts.protos.VPNServerArmadilloObject.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accounts.protos.VPNServerArmadilloObject} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accounts.protos.VPNServerArmadilloObject.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: (f = jspb.Message.getField(msg, 1)) == null ? undefined : f,
    nonce: (f = jspb.Message.getField(msg, 2)) == null ? undefined : f,
    mnemonic: (f = jspb.Message.getField(msg, 3)) == null ? undefined : f,
    name: (f = jspb.Message.getField(msg, 4)) == null ? undefined : f,
    status: (f = jspb.Message.getField(msg, 5)) == null ? undefined : f,
    isEnabled: (f = jspb.Message.getBooleanField(msg, 6)) == null ? undefined : f,
    publicIp: (f = jspb.Message.getField(msg, 7)) == null ? undefined : f,
    lastSeen: (f = jspb.Message.getField(msg, 8)) == null ? undefined : f,
    hostId: (f = jspb.Message.getField(msg, 9)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accounts.protos.VPNServerArmadilloObject}
 */
proto.accounts.protos.VPNServerArmadilloObject.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accounts.protos.VPNServerArmadilloObject;
  return proto.accounts.protos.VPNServerArmadilloObject.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accounts.protos.VPNServerArmadilloObject} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accounts.protos.VPNServerArmadilloObject}
 */
proto.accounts.protos.VPNServerArmadilloObject.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setNonce(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setMnemonic(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 5:
      var value = /** @type {!proto.accounts.protos.VPNServerAppStatus} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsEnabled(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setPublicIp(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setLastSeen(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setHostId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accounts.protos.VPNServerArmadilloObject.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accounts.protos.VPNServerArmadilloObject.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accounts.protos.VPNServerArmadilloObject} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accounts.protos.VPNServerArmadilloObject.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {string} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeString(
      1,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeString(
      2,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeString(
      3,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeString(
      4,
      f
    );
  }
  f = /** @type {!proto.accounts.protos.VPNServerAppStatus} */ (jspb.Message.getField(message, 5));
  if (f != null) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 6));
  if (f != null) {
    writer.writeBool(
      6,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 7));
  if (f != null) {
    writer.writeString(
      7,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 8));
  if (f != null) {
    writer.writeString(
      8,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 9));
  if (f != null) {
    writer.writeString(
      9,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.accounts.protos.VPNServerArmadilloObject.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.accounts.protos.VPNServerArmadilloObject} returns this
 */
proto.accounts.protos.VPNServerArmadilloObject.prototype.setId = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.VPNServerArmadilloObject} returns this
 */
proto.accounts.protos.VPNServerArmadilloObject.prototype.clearId = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.VPNServerArmadilloObject.prototype.hasId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string nonce = 2;
 * @return {string}
 */
proto.accounts.protos.VPNServerArmadilloObject.prototype.getNonce = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.accounts.protos.VPNServerArmadilloObject} returns this
 */
proto.accounts.protos.VPNServerArmadilloObject.prototype.setNonce = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.VPNServerArmadilloObject} returns this
 */
proto.accounts.protos.VPNServerArmadilloObject.prototype.clearNonce = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.VPNServerArmadilloObject.prototype.hasNonce = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string mnemonic = 3;
 * @return {string}
 */
proto.accounts.protos.VPNServerArmadilloObject.prototype.getMnemonic = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.accounts.protos.VPNServerArmadilloObject} returns this
 */
proto.accounts.protos.VPNServerArmadilloObject.prototype.setMnemonic = function(value) {
  return jspb.Message.setField(this, 3, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.VPNServerArmadilloObject} returns this
 */
proto.accounts.protos.VPNServerArmadilloObject.prototype.clearMnemonic = function() {
  return jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.VPNServerArmadilloObject.prototype.hasMnemonic = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional string name = 4;
 * @return {string}
 */
proto.accounts.protos.VPNServerArmadilloObject.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.accounts.protos.VPNServerArmadilloObject} returns this
 */
proto.accounts.protos.VPNServerArmadilloObject.prototype.setName = function(value) {
  return jspb.Message.setField(this, 4, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.VPNServerArmadilloObject} returns this
 */
proto.accounts.protos.VPNServerArmadilloObject.prototype.clearName = function() {
  return jspb.Message.setField(this, 4, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.VPNServerArmadilloObject.prototype.hasName = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional VPNServerAppStatus status = 5;
 * @return {!proto.accounts.protos.VPNServerAppStatus}
 */
proto.accounts.protos.VPNServerArmadilloObject.prototype.getStatus = function() {
  return /** @type {!proto.accounts.protos.VPNServerAppStatus} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.accounts.protos.VPNServerAppStatus} value
 * @return {!proto.accounts.protos.VPNServerArmadilloObject} returns this
 */
proto.accounts.protos.VPNServerArmadilloObject.prototype.setStatus = function(value) {
  return jspb.Message.setField(this, 5, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.VPNServerArmadilloObject} returns this
 */
proto.accounts.protos.VPNServerArmadilloObject.prototype.clearStatus = function() {
  return jspb.Message.setField(this, 5, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.VPNServerArmadilloObject.prototype.hasStatus = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional bool is_enabled = 6;
 * @return {boolean}
 */
proto.accounts.protos.VPNServerArmadilloObject.prototype.getIsEnabled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 6, false));
};


/**
 * @param {boolean} value
 * @return {!proto.accounts.protos.VPNServerArmadilloObject} returns this
 */
proto.accounts.protos.VPNServerArmadilloObject.prototype.setIsEnabled = function(value) {
  return jspb.Message.setField(this, 6, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.VPNServerArmadilloObject} returns this
 */
proto.accounts.protos.VPNServerArmadilloObject.prototype.clearIsEnabled = function() {
  return jspb.Message.setField(this, 6, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.VPNServerArmadilloObject.prototype.hasIsEnabled = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional string public_ip = 7;
 * @return {string}
 */
proto.accounts.protos.VPNServerArmadilloObject.prototype.getPublicIp = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.accounts.protos.VPNServerArmadilloObject} returns this
 */
proto.accounts.protos.VPNServerArmadilloObject.prototype.setPublicIp = function(value) {
  return jspb.Message.setField(this, 7, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.VPNServerArmadilloObject} returns this
 */
proto.accounts.protos.VPNServerArmadilloObject.prototype.clearPublicIp = function() {
  return jspb.Message.setField(this, 7, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.VPNServerArmadilloObject.prototype.hasPublicIp = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional string last_seen = 8;
 * @return {string}
 */
proto.accounts.protos.VPNServerArmadilloObject.prototype.getLastSeen = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.accounts.protos.VPNServerArmadilloObject} returns this
 */
proto.accounts.protos.VPNServerArmadilloObject.prototype.setLastSeen = function(value) {
  return jspb.Message.setField(this, 8, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.VPNServerArmadilloObject} returns this
 */
proto.accounts.protos.VPNServerArmadilloObject.prototype.clearLastSeen = function() {
  return jspb.Message.setField(this, 8, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.VPNServerArmadilloObject.prototype.hasLastSeen = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional string host_id = 9;
 * @return {string}
 */
proto.accounts.protos.VPNServerArmadilloObject.prototype.getHostId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.accounts.protos.VPNServerArmadilloObject} returns this
 */
proto.accounts.protos.VPNServerArmadilloObject.prototype.setHostId = function(value) {
  return jspb.Message.setField(this, 9, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.VPNServerArmadilloObject} returns this
 */
proto.accounts.protos.VPNServerArmadilloObject.prototype.clearHostId = function() {
  return jspb.Message.setField(this, 9, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.VPNServerArmadilloObject.prototype.hasHostId = function() {
  return jspb.Message.getField(this, 9) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.accounts.protos.VPNServerArmadilloError.repeatedFields_ = [1,2,3,4,5,6,7,8,9];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accounts.protos.VPNServerArmadilloError.prototype.toObject = function(opt_includeInstance) {
  return proto.accounts.protos.VPNServerArmadilloError.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accounts.protos.VPNServerArmadilloError} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accounts.protos.VPNServerArmadilloError.toObject = function(includeInstance, msg) {
  var f, obj = {
    idList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f,
    nonceList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f,
    mnemonicList: (f = jspb.Message.getRepeatedField(msg, 3)) == null ? undefined : f,
    nameList: (f = jspb.Message.getRepeatedField(msg, 4)) == null ? undefined : f,
    statusList: (f = jspb.Message.getRepeatedField(msg, 5)) == null ? undefined : f,
    isEnabledList: (f = jspb.Message.getRepeatedField(msg, 6)) == null ? undefined : f,
    publicIpList: (f = jspb.Message.getRepeatedField(msg, 7)) == null ? undefined : f,
    lastSeenList: (f = jspb.Message.getRepeatedField(msg, 8)) == null ? undefined : f,
    hostIdList: (f = jspb.Message.getRepeatedField(msg, 9)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accounts.protos.VPNServerArmadilloError}
 */
proto.accounts.protos.VPNServerArmadilloError.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accounts.protos.VPNServerArmadilloError;
  return proto.accounts.protos.VPNServerArmadilloError.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accounts.protos.VPNServerArmadilloError} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accounts.protos.VPNServerArmadilloError}
 */
proto.accounts.protos.VPNServerArmadilloError.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.addNonce(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.addMnemonic(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.addName(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.addStatus(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.addIsEnabled(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.addPublicIp(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.addLastSeen(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.addHostId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accounts.protos.VPNServerArmadilloError.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accounts.protos.VPNServerArmadilloError.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accounts.protos.VPNServerArmadilloError} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accounts.protos.VPNServerArmadilloError.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIdList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
  f = message.getNonceList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      2,
      f
    );
  }
  f = message.getMnemonicList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      3,
      f
    );
  }
  f = message.getNameList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      4,
      f
    );
  }
  f = message.getStatusList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      5,
      f
    );
  }
  f = message.getIsEnabledList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      6,
      f
    );
  }
  f = message.getPublicIpList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      7,
      f
    );
  }
  f = message.getLastSeenList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      8,
      f
    );
  }
  f = message.getHostIdList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      9,
      f
    );
  }
};


/**
 * repeated string id = 1;
 * @return {!Array<string>}
 */
proto.accounts.protos.VPNServerArmadilloError.prototype.getIdList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.accounts.protos.VPNServerArmadilloError} returns this
 */
proto.accounts.protos.VPNServerArmadilloError.prototype.setIdList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.accounts.protos.VPNServerArmadilloError} returns this
 */
proto.accounts.protos.VPNServerArmadilloError.prototype.addId = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.accounts.protos.VPNServerArmadilloError} returns this
 */
proto.accounts.protos.VPNServerArmadilloError.prototype.clearIdList = function() {
  return this.setIdList([]);
};


/**
 * repeated string nonce = 2;
 * @return {!Array<string>}
 */
proto.accounts.protos.VPNServerArmadilloError.prototype.getNonceList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.accounts.protos.VPNServerArmadilloError} returns this
 */
proto.accounts.protos.VPNServerArmadilloError.prototype.setNonceList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.accounts.protos.VPNServerArmadilloError} returns this
 */
proto.accounts.protos.VPNServerArmadilloError.prototype.addNonce = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.accounts.protos.VPNServerArmadilloError} returns this
 */
proto.accounts.protos.VPNServerArmadilloError.prototype.clearNonceList = function() {
  return this.setNonceList([]);
};


/**
 * repeated string mnemonic = 3;
 * @return {!Array<string>}
 */
proto.accounts.protos.VPNServerArmadilloError.prototype.getMnemonicList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 3));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.accounts.protos.VPNServerArmadilloError} returns this
 */
proto.accounts.protos.VPNServerArmadilloError.prototype.setMnemonicList = function(value) {
  return jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.accounts.protos.VPNServerArmadilloError} returns this
 */
proto.accounts.protos.VPNServerArmadilloError.prototype.addMnemonic = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.accounts.protos.VPNServerArmadilloError} returns this
 */
proto.accounts.protos.VPNServerArmadilloError.prototype.clearMnemonicList = function() {
  return this.setMnemonicList([]);
};


/**
 * repeated string name = 4;
 * @return {!Array<string>}
 */
proto.accounts.protos.VPNServerArmadilloError.prototype.getNameList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 4));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.accounts.protos.VPNServerArmadilloError} returns this
 */
proto.accounts.protos.VPNServerArmadilloError.prototype.setNameList = function(value) {
  return jspb.Message.setField(this, 4, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.accounts.protos.VPNServerArmadilloError} returns this
 */
proto.accounts.protos.VPNServerArmadilloError.prototype.addName = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 4, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.accounts.protos.VPNServerArmadilloError} returns this
 */
proto.accounts.protos.VPNServerArmadilloError.prototype.clearNameList = function() {
  return this.setNameList([]);
};


/**
 * repeated string status = 5;
 * @return {!Array<string>}
 */
proto.accounts.protos.VPNServerArmadilloError.prototype.getStatusList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 5));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.accounts.protos.VPNServerArmadilloError} returns this
 */
proto.accounts.protos.VPNServerArmadilloError.prototype.setStatusList = function(value) {
  return jspb.Message.setField(this, 5, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.accounts.protos.VPNServerArmadilloError} returns this
 */
proto.accounts.protos.VPNServerArmadilloError.prototype.addStatus = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 5, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.accounts.protos.VPNServerArmadilloError} returns this
 */
proto.accounts.protos.VPNServerArmadilloError.prototype.clearStatusList = function() {
  return this.setStatusList([]);
};


/**
 * repeated string is_enabled = 6;
 * @return {!Array<string>}
 */
proto.accounts.protos.VPNServerArmadilloError.prototype.getIsEnabledList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 6));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.accounts.protos.VPNServerArmadilloError} returns this
 */
proto.accounts.protos.VPNServerArmadilloError.prototype.setIsEnabledList = function(value) {
  return jspb.Message.setField(this, 6, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.accounts.protos.VPNServerArmadilloError} returns this
 */
proto.accounts.protos.VPNServerArmadilloError.prototype.addIsEnabled = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 6, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.accounts.protos.VPNServerArmadilloError} returns this
 */
proto.accounts.protos.VPNServerArmadilloError.prototype.clearIsEnabledList = function() {
  return this.setIsEnabledList([]);
};


/**
 * repeated string public_ip = 7;
 * @return {!Array<string>}
 */
proto.accounts.protos.VPNServerArmadilloError.prototype.getPublicIpList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 7));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.accounts.protos.VPNServerArmadilloError} returns this
 */
proto.accounts.protos.VPNServerArmadilloError.prototype.setPublicIpList = function(value) {
  return jspb.Message.setField(this, 7, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.accounts.protos.VPNServerArmadilloError} returns this
 */
proto.accounts.protos.VPNServerArmadilloError.prototype.addPublicIp = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 7, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.accounts.protos.VPNServerArmadilloError} returns this
 */
proto.accounts.protos.VPNServerArmadilloError.prototype.clearPublicIpList = function() {
  return this.setPublicIpList([]);
};


/**
 * repeated string last_seen = 8;
 * @return {!Array<string>}
 */
proto.accounts.protos.VPNServerArmadilloError.prototype.getLastSeenList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 8));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.accounts.protos.VPNServerArmadilloError} returns this
 */
proto.accounts.protos.VPNServerArmadilloError.prototype.setLastSeenList = function(value) {
  return jspb.Message.setField(this, 8, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.accounts.protos.VPNServerArmadilloError} returns this
 */
proto.accounts.protos.VPNServerArmadilloError.prototype.addLastSeen = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 8, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.accounts.protos.VPNServerArmadilloError} returns this
 */
proto.accounts.protos.VPNServerArmadilloError.prototype.clearLastSeenList = function() {
  return this.setLastSeenList([]);
};


/**
 * repeated string host_id = 9;
 * @return {!Array<string>}
 */
proto.accounts.protos.VPNServerArmadilloError.prototype.getHostIdList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 9));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.accounts.protos.VPNServerArmadilloError} returns this
 */
proto.accounts.protos.VPNServerArmadilloError.prototype.setHostIdList = function(value) {
  return jspb.Message.setField(this, 9, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.accounts.protos.VPNServerArmadilloError} returns this
 */
proto.accounts.protos.VPNServerArmadilloError.prototype.addHostId = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 9, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.accounts.protos.VPNServerArmadilloError} returns this
 */
proto.accounts.protos.VPNServerArmadilloError.prototype.clearHostIdList = function() {
  return this.setHostIdList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.accounts.protos.VPNServerArmadilloListResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accounts.protos.VPNServerArmadilloListResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.accounts.protos.VPNServerArmadilloListResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accounts.protos.VPNServerArmadilloListResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accounts.protos.VPNServerArmadilloListResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    clientsList: jspb.Message.toObjectList(msg.getClientsList(),
    proto.accounts.protos.VPNServerArmadilloObject.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accounts.protos.VPNServerArmadilloListResponse}
 */
proto.accounts.protos.VPNServerArmadilloListResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accounts.protos.VPNServerArmadilloListResponse;
  return proto.accounts.protos.VPNServerArmadilloListResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accounts.protos.VPNServerArmadilloListResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accounts.protos.VPNServerArmadilloListResponse}
 */
proto.accounts.protos.VPNServerArmadilloListResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.accounts.protos.VPNServerArmadilloObject;
      reader.readMessage(value,proto.accounts.protos.VPNServerArmadilloObject.deserializeBinaryFromReader);
      msg.addClients(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accounts.protos.VPNServerArmadilloListResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accounts.protos.VPNServerArmadilloListResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accounts.protos.VPNServerArmadilloListResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accounts.protos.VPNServerArmadilloListResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getClientsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.accounts.protos.VPNServerArmadilloObject.serializeBinaryToWriter
    );
  }
};


/**
 * repeated VPNServerArmadilloObject clients = 1;
 * @return {!Array<!proto.accounts.protos.VPNServerArmadilloObject>}
 */
proto.accounts.protos.VPNServerArmadilloListResponse.prototype.getClientsList = function() {
  return /** @type{!Array<!proto.accounts.protos.VPNServerArmadilloObject>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.accounts.protos.VPNServerArmadilloObject, 1));
};


/**
 * @param {!Array<!proto.accounts.protos.VPNServerArmadilloObject>} value
 * @return {!proto.accounts.protos.VPNServerArmadilloListResponse} returns this
*/
proto.accounts.protos.VPNServerArmadilloListResponse.prototype.setClientsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.accounts.protos.VPNServerArmadilloObject=} opt_value
 * @param {number=} opt_index
 * @return {!proto.accounts.protos.VPNServerArmadilloObject}
 */
proto.accounts.protos.VPNServerArmadilloListResponse.prototype.addClients = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.accounts.protos.VPNServerArmadilloObject, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.accounts.protos.VPNServerArmadilloListResponse} returns this
 */
proto.accounts.protos.VPNServerArmadilloListResponse.prototype.clearClientsList = function() {
  return this.setClientsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accounts.protos.VPNServerArmadilloCreateResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.accounts.protos.VPNServerArmadilloCreateResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accounts.protos.VPNServerArmadilloCreateResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accounts.protos.VPNServerArmadilloCreateResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    client: (f = msg.getClient()) && proto.accounts.protos.VPNServerArmadilloObject.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accounts.protos.VPNServerArmadilloCreateResponse}
 */
proto.accounts.protos.VPNServerArmadilloCreateResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accounts.protos.VPNServerArmadilloCreateResponse;
  return proto.accounts.protos.VPNServerArmadilloCreateResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accounts.protos.VPNServerArmadilloCreateResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accounts.protos.VPNServerArmadilloCreateResponse}
 */
proto.accounts.protos.VPNServerArmadilloCreateResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.accounts.protos.VPNServerArmadilloObject;
      reader.readMessage(value,proto.accounts.protos.VPNServerArmadilloObject.deserializeBinaryFromReader);
      msg.setClient(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accounts.protos.VPNServerArmadilloCreateResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accounts.protos.VPNServerArmadilloCreateResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accounts.protos.VPNServerArmadilloCreateResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accounts.protos.VPNServerArmadilloCreateResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getClient();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.accounts.protos.VPNServerArmadilloObject.serializeBinaryToWriter
    );
  }
};


/**
 * required VPNServerArmadilloObject client = 1;
 * @return {!proto.accounts.protos.VPNServerArmadilloObject}
 */
proto.accounts.protos.VPNServerArmadilloCreateResponse.prototype.getClient = function() {
  return /** @type{!proto.accounts.protos.VPNServerArmadilloObject} */ (
    jspb.Message.getWrapperField(this, proto.accounts.protos.VPNServerArmadilloObject, 1, 1));
};


/**
 * @param {!proto.accounts.protos.VPNServerArmadilloObject} value
 * @return {!proto.accounts.protos.VPNServerArmadilloCreateResponse} returns this
*/
proto.accounts.protos.VPNServerArmadilloCreateResponse.prototype.setClient = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.VPNServerArmadilloCreateResponse} returns this
 */
proto.accounts.protos.VPNServerArmadilloCreateResponse.prototype.clearClient = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.VPNServerArmadilloCreateResponse.prototype.hasClient = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accounts.protos.VPNServerArmadilloGetResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.accounts.protos.VPNServerArmadilloGetResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accounts.protos.VPNServerArmadilloGetResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accounts.protos.VPNServerArmadilloGetResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    client: (f = msg.getClient()) && proto.accounts.protos.VPNServerArmadilloObject.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accounts.protos.VPNServerArmadilloGetResponse}
 */
proto.accounts.protos.VPNServerArmadilloGetResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accounts.protos.VPNServerArmadilloGetResponse;
  return proto.accounts.protos.VPNServerArmadilloGetResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accounts.protos.VPNServerArmadilloGetResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accounts.protos.VPNServerArmadilloGetResponse}
 */
proto.accounts.protos.VPNServerArmadilloGetResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.accounts.protos.VPNServerArmadilloObject;
      reader.readMessage(value,proto.accounts.protos.VPNServerArmadilloObject.deserializeBinaryFromReader);
      msg.setClient(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accounts.protos.VPNServerArmadilloGetResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accounts.protos.VPNServerArmadilloGetResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accounts.protos.VPNServerArmadilloGetResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accounts.protos.VPNServerArmadilloGetResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getClient();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.accounts.protos.VPNServerArmadilloObject.serializeBinaryToWriter
    );
  }
};


/**
 * required VPNServerArmadilloObject client = 1;
 * @return {!proto.accounts.protos.VPNServerArmadilloObject}
 */
proto.accounts.protos.VPNServerArmadilloGetResponse.prototype.getClient = function() {
  return /** @type{!proto.accounts.protos.VPNServerArmadilloObject} */ (
    jspb.Message.getWrapperField(this, proto.accounts.protos.VPNServerArmadilloObject, 1, 1));
};


/**
 * @param {!proto.accounts.protos.VPNServerArmadilloObject} value
 * @return {!proto.accounts.protos.VPNServerArmadilloGetResponse} returns this
*/
proto.accounts.protos.VPNServerArmadilloGetResponse.prototype.setClient = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.VPNServerArmadilloGetResponse} returns this
 */
proto.accounts.protos.VPNServerArmadilloGetResponse.prototype.clearClient = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.VPNServerArmadilloGetResponse.prototype.hasClient = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accounts.protos.VPNServerArmadilloSetRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.accounts.protos.VPNServerArmadilloSetRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accounts.protos.VPNServerArmadilloSetRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accounts.protos.VPNServerArmadilloSetRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    client: (f = msg.getClient()) && proto.accounts.protos.VPNServerArmadilloObject.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accounts.protos.VPNServerArmadilloSetRequest}
 */
proto.accounts.protos.VPNServerArmadilloSetRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accounts.protos.VPNServerArmadilloSetRequest;
  return proto.accounts.protos.VPNServerArmadilloSetRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accounts.protos.VPNServerArmadilloSetRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accounts.protos.VPNServerArmadilloSetRequest}
 */
proto.accounts.protos.VPNServerArmadilloSetRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.accounts.protos.VPNServerArmadilloObject;
      reader.readMessage(value,proto.accounts.protos.VPNServerArmadilloObject.deserializeBinaryFromReader);
      msg.setClient(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accounts.protos.VPNServerArmadilloSetRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accounts.protos.VPNServerArmadilloSetRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accounts.protos.VPNServerArmadilloSetRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accounts.protos.VPNServerArmadilloSetRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getClient();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.accounts.protos.VPNServerArmadilloObject.serializeBinaryToWriter
    );
  }
};


/**
 * required VPNServerArmadilloObject client = 1;
 * @return {!proto.accounts.protos.VPNServerArmadilloObject}
 */
proto.accounts.protos.VPNServerArmadilloSetRequest.prototype.getClient = function() {
  return /** @type{!proto.accounts.protos.VPNServerArmadilloObject} */ (
    jspb.Message.getWrapperField(this, proto.accounts.protos.VPNServerArmadilloObject, 1, 1));
};


/**
 * @param {!proto.accounts.protos.VPNServerArmadilloObject} value
 * @return {!proto.accounts.protos.VPNServerArmadilloSetRequest} returns this
*/
proto.accounts.protos.VPNServerArmadilloSetRequest.prototype.setClient = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.VPNServerArmadilloSetRequest} returns this
 */
proto.accounts.protos.VPNServerArmadilloSetRequest.prototype.clearClient = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.VPNServerArmadilloSetRequest.prototype.hasClient = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accounts.protos.VPNServerArmadilloSetResponseInvalid.prototype.toObject = function(opt_includeInstance) {
  return proto.accounts.protos.VPNServerArmadilloSetResponseInvalid.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accounts.protos.VPNServerArmadilloSetResponseInvalid} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accounts.protos.VPNServerArmadilloSetResponseInvalid.toObject = function(includeInstance, msg) {
  var f, obj = {
    client: (f = msg.getClient()) && proto.accounts.protos.VPNServerArmadilloError.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accounts.protos.VPNServerArmadilloSetResponseInvalid}
 */
proto.accounts.protos.VPNServerArmadilloSetResponseInvalid.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accounts.protos.VPNServerArmadilloSetResponseInvalid;
  return proto.accounts.protos.VPNServerArmadilloSetResponseInvalid.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accounts.protos.VPNServerArmadilloSetResponseInvalid} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accounts.protos.VPNServerArmadilloSetResponseInvalid}
 */
proto.accounts.protos.VPNServerArmadilloSetResponseInvalid.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.accounts.protos.VPNServerArmadilloError;
      reader.readMessage(value,proto.accounts.protos.VPNServerArmadilloError.deserializeBinaryFromReader);
      msg.setClient(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accounts.protos.VPNServerArmadilloSetResponseInvalid.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accounts.protos.VPNServerArmadilloSetResponseInvalid.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accounts.protos.VPNServerArmadilloSetResponseInvalid} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accounts.protos.VPNServerArmadilloSetResponseInvalid.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getClient();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.accounts.protos.VPNServerArmadilloError.serializeBinaryToWriter
    );
  }
};


/**
 * required VPNServerArmadilloError client = 1;
 * @return {!proto.accounts.protos.VPNServerArmadilloError}
 */
proto.accounts.protos.VPNServerArmadilloSetResponseInvalid.prototype.getClient = function() {
  return /** @type{!proto.accounts.protos.VPNServerArmadilloError} */ (
    jspb.Message.getWrapperField(this, proto.accounts.protos.VPNServerArmadilloError, 1, 1));
};


/**
 * @param {!proto.accounts.protos.VPNServerArmadilloError} value
 * @return {!proto.accounts.protos.VPNServerArmadilloSetResponseInvalid} returns this
*/
proto.accounts.protos.VPNServerArmadilloSetResponseInvalid.prototype.setClient = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.VPNServerArmadilloSetResponseInvalid} returns this
 */
proto.accounts.protos.VPNServerArmadilloSetResponseInvalid.prototype.clearClient = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.VPNServerArmadilloSetResponseInvalid.prototype.hasClient = function() {
  return jspb.Message.getField(this, 1) != null;
};


goog.object.extend(exports, proto.accounts.protos);
